import { render, staticRenderFns } from "./DashboardEditSection.vue?vue&type=template&id=053a3973&scoped=true"
import script from "./DashboardEditSection.vue?vue&type=script&lang=js"
export * from "./DashboardEditSection.vue?vue&type=script&lang=js"
import style0 from "./DashboardEditSection.vue?vue&type=style&index=0&id=053a3973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053a3973",
  null
  
)

export default component.exports